import React, { Component } from 'react'

class WeldTypeMultiSelectEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || ''
    }
  }

  getValue() {
    return {
      [this.props.column.key]: this.state.value
    }
  }

  getInputNode() {
    return this.input
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value })
  }

  render() {
    return (
      <input
        ref={node => this.input = node}
        type="text"
        value={this.state.value}
        onChange={this.handleChange}
        placeholder="Enter weld types (comma separated)"
        style={{ width: '100%', height: '100%', border: 'none', outline: 'none' }}
        autoFocus
      />
    )
  }
}

export default WeldTypeMultiSelectEditor


// WEBPACK FOOTER //
// ./src/components/Welds/helpers/WeldTypeMultiSelectEditor.js